module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-180.724fe355.jpg";